/* ==========================================================================
   Ambela Main Banner
   Measures the site header so a banner can sit *behind* it, and keeps the
   banner's content clear of the header/announcement bar.

   Two values are published on :root —
     --ambela-hdr-pull : how far to pull the banner up under the header.
                         0 when the theme's transparent header is on, because
                         the header is already absolutely positioned and the
                         banner flows underneath it on its own.
     --ambela-hdr-safe : the vertical space content must avoid, measured from
                         the top of the banner to the bottom of the header.
   ========================================================================== */
(function () {
  'use strict';

  var HEADER_SELECTORS = [
    '.section-header .header',
    'sticky-on-scroll.header',
    'sticky-always.header',
    '.header',
  ];

  function findHeader() {
    for (var i = 0; i < HEADER_SELECTORS.length; i++) {
      var el = document.querySelector(HEADER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  /* True when the header is lifted out of normal document flow, which is what
     the theme's transparent-header setting does. In that case the banner
     already sits underneath it and must not be pulled up again. */
  function headerOverlays(header) {
    var position = window.getComputedStyle(header).position;
    return position === 'absolute' || position === 'fixed' || position === 'sticky';
  }

  function measure() {
    var banners = document.querySelectorAll('[data-ambela-banner-behind]');
    if (!banners.length) return;

    var header = findHeader();
    if (!header) return;

    /* Sticky headers move as you scroll, so only trust a measurement taken
       at the top of the page. Otherwise keep the value already published. */
    var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (scrolled > 4 && document.documentElement.style.getPropertyValue('--ambela-hdr-safe')) {
      return;
    }

    var root = document.documentElement;
    var headerHeight = header.offsetHeight || 0;
    var overlays = headerOverlays(header);

    root.style.setProperty('--ambela-hdr-pull', (overlays ? 0 : headerHeight) + 'px');

    /* Measure the safe area after the pull has been applied, so the number
       reflects the banner's final resting position. This also picks up any
       announcement bar sitting above the header. */
    window.requestAnimationFrame(function () {
      var headerRect = header.getBoundingClientRect();
      var headerBottom = headerRect.bottom + scrolled;
      var safe = headerHeight;

      var first = banners[0];
      if (first) {
        var bannerTop = first.getBoundingClientRect().top + scrolled;
        var measured = headerBottom - bannerTop;
        if (measured > 0) safe = measured;
      }

      root.style.setProperty('--ambela-hdr-safe', Math.max(0, Math.round(safe)) + 'px');
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      measure();
    });
  }

  function init() {
    measure();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    /* Late-loading webfonts and logos change the header's height. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(function () {});
    }
    window.addEventListener('load', schedule);

    var header = findHeader();
    if (header && 'ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-measure whenever a section is re-rendered. */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  /* --------------------------------------------------------------------
     Background video: some browsers refuse the initial autoplay. Nudge any
     paused background video once it scrolls into view.
     -------------------------------------------------------------------- */
  function primeVideos(scope) {
    var videos = (scope || document).querySelectorAll('.ambela-banner__media video');
    Array.prototype.forEach.call(videos, function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      primeVideos();
    });
  } else {
    primeVideos();
  }

  document.addEventListener('shopify:section:load', function (event) {
    primeVideos(event.target);
  });
})();
